// extracted by mini-css-extract-plugin
export var container = "styles-module--container--62d9b";
export var svg = "styles-module--svg--03c69";